__turbopack_context__.v({
  "root": "Notifications-module__Fms2oG__root",
});
